






































import FooterButton from "@/components/FooterButton.vue";
import { Component, Mixins } from "vue-property-decorator";
import { ContentService } from "@/service/content.service";
import { MatchGSRPContent } from "@/models/content/match-gsrp";
import CommonMixin, {
  WORKFLOW_PREFERRED_GREAT_START,
} from "@/mixins/common-mixins";
import { AppData, CareGiver } from "@/models/app-data";
import { WorkflowService } from "@/service/workflow.service";
import { Route } from "vue-router";
import PageLoader from "@/components/PageLoader.vue"

@Component({
  components: {
    FooterButton,
    PageLoader
  },
})
export default class MatchGSRP extends Mixins(CommonMixin) {
  workflowService = new WorkflowService();
  content: MatchGSRPContent = {} as MatchGSRPContent;
  appData = {} as AppData;
  loadDataFinished = false;
  textDirection = "ltr";
  checkTextAlign = "has-text-left";

  async mounted(): Promise<void> {
    try {
      const contentService = new ContentService(this.$route);
      this.content = await contentService.getMatchGSRPContent();
      this.textDirection = contentService.TextDirection();  
      await this.loadData();
    } catch (error) {
      this.showError(error);
    }
  }

  public handleNextPageEvent(): void {
    this.$router.push({ path: "GSRPPickPrograms" });
  }

  async loadData(): Promise<void> {
    if (this.$route?.query?.workflowid != null) {
      const workflowId = this.$route.query.workflowid + "";
      this.appData = await this.workflowToAppData(workflowId);
      await this.putWorkflowStep( this.appData.workflowId, "MatchGSRP") 
      this.saveAppData(this.appData);
    } else {
      this.appData = this.getAppData();
      if (this.appData != null) {
        this.appData.preferredProgram = WORKFLOW_PREFERRED_GREAT_START;
        this.saveAppData(this.appData);
        await this.putWorkflowStep( this.appData.workflowId, "MatchGSRP") 
        await this.postWorkflowEligible(
          this.appData.workflowId,
          this.appData.preferredProgram
        );
      }
    }
    this.loadDataFinished = true;
  }

  disableNext(): boolean {
    return !this.loadDataFinished;
  }
}
